export enum AccountSection {
  Assets = 'assets',
  Payables = 'payables',
  PartnersCapital = 'partnersCapital',
  Income = 'income',
  Expenses = 'expenses',
}
